<div class="login-container">
    <div style="display: flex;flex-direction: column;justify-content: space-between;align-items: center;">
        <img src="../../../public/logo.png" style="max-width: 150px;margin-bottom: 20px;"/>
    </div>
    <form @submit.prevent="login">
        <div class="form-group">
            <label for="username">Username</label>
            <input type="text" v-model="username" id="username" required />
        </div>
        <div class="form-group">
            <label for="password">Password</label>
            <input type="password" v-model="password" id="password" required />
        </div>
        <button type="submit">Login</button>
    </form>
</div>
